/**
 * Load the static data bundle.
 *
 * The service worker precaches it, so after the first successful load the app opens
 * with no network at all. This function only has to handle the cold-start case.
 */

import type { Bundle } from '@tlv/shared';

export interface BundleLoadResult {
  bundle: Bundle;
  /** Bytes, for the about panel. */
  sizeHint: number;
}

export async function loadBundle(): Promise<BundleLoadResult> {
  const response = await fetch(`${import.meta.env.BASE_URL}bundle.json`, { cache: 'default' });

  if (!response.ok) {
    throw new Error(
      `Could not load bundle.json (HTTP ${response.status}). ` +
        'Build one with: npm run fixture && npm run pipeline:matrix && ' +
        'npm run pipeline:density && npm run pipeline:bundle',
    );
  }

  const text = await response.text();
  const bundle = JSON.parse(text) as Bundle;

  if (!bundle.venues || !bundle.reach) {
    throw new Error('bundle.json is missing venues or reach data — rebuild it.');
  }

  return { bundle, sizeHint: text.length };
}
